import React from 'react'

export const ArrowDownCircle = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='27'
    height='28'
    viewBox='0 0 27 28'
    {...props}
  >
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M13.4998 0.666016C6.13604 0.666016 0.166504 6.63555 0.166504 13.9993C0.166504 21.3631 6.13604 27.3327 13.4998 27.3327C20.8636 27.3327 26.8332 21.3631 26.8332 13.9993C26.8332 6.63555 20.8636 0.666016 13.4998 0.666016ZM19.1564 14.0053C18.6356 13.4847 17.7914 13.4847 17.2708 14.0053L14.8332 16.4429V8.34244C14.8332 7.60606 14.2362 7.00911 13.4998 7.00911C12.7634 7.00911 12.1665 7.60606 12.1665 8.34244V16.4436L9.72821 14.0053C9.20752 13.4847 8.3633 13.4847 7.8426 14.0053C7.3219 14.526 7.3219 15.3703 7.8426 15.8909L12.5566 20.6051C13.0773 21.1257 13.9216 21.1257 14.4422 20.6051L19.1564 15.8909C19.677 15.3703 19.677 14.526 19.1564 14.0053Z'
    />
  </svg>
)
